import React from 'react';
import {
  bool,
  func,
  number,
  oneOf,
  shape,
  string,
} from 'prop-types';

import FormInputContainer from '../../../scaffolding/FormInputContainer/FormInputContainer';
import InputV2 from '../../../controls/InputV2/InputV2';
import { PasswordTooltip } from '../../../shared';
import PasswordValidationV2 from '../../../controls/PasswordValidationV2/PasswordValidationV2';

const PasswordWithLabelV2 = ({
  id,
  label,
  value,
  required = true,
  title = '',
  errorMsg = null,
  maxLength,
  onChange,
  validity,
  autocomplete = null,
  selectAllOnFocus,
}) => (
  <FormInputContainer id={`${id}_container`}>
    <div className="tooltipLabel">
      <label id={`${id}_label`} htmlFor={id}>
        {label}
      </label>
      {/* TODO: Remove this bizarre ternary in the ID after deprecation of v1 */}
      <PasswordTooltip id={id === 'password' ? 'pwTooltip' : `${id}_tooltip`} />
    </div>

    <InputV2
      value={value}
      id={id}
      type="password"
      autocomplete={autocomplete}
      onChange={onChange}
      required={required}
      title={title}
      hasError={errorMsg?.length > 0}
      errorMsg={errorMsg}
      placeholder={title}
      selectAllOnFocus={selectAllOnFocus}
      maxLength={maxLength}
      ariaDescribedBy={!errorMsg?.length ? 'passwordChecks' : null}
    />

    <PasswordValidationV2 id="passwordChecks" {...validity} />
  </FormInputContainer>
);

PasswordWithLabelV2.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  value: string.isRequired,
  required: bool,
  title: string,
  errorMsg: string,
  maxLength: oneOf([number, string]).isRequired,
  onChange: func.isRequired,
  validity: shape({
    eight: bool.isRequired,
    upper: bool.isRequired,
    lower: bool.isRequired,
    number: bool.isRequired,
    special: bool.isRequired,
  }).isRequired,
  autocomplete: oneOf([string, bool]),
  selectAllOnFocus: bool,
};

PasswordWithLabelV2.defaultProps = {
  required: true,
  title: '',
  selectAllOnFocus: false,
  errorMsg: null,
  autocomplete: null,
};

export default PasswordWithLabelV2;
